export default build =>
    build.mutation({
        query(payload) {
            console.log("payload",payload)
            return {
                url: '/exam/updatetaluka',
                method: 'POST',
                body: payload,
               
            };
        },
        invalidatesTags: ['allTalukas'],
    })
